import config from "config.json";
import httpService from "./httpService";
import sessionStorageService from "./sessionStorageService";
import { getRoles, getUserPermission } from "./permissionService";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { redirect } from "react-router-dom";
import layout2Settings from "app/GullLayout/Layout2/Layout2Settings";
import layout1Settings from "app/GullLayout/Layout1/Layout1Settings";

// setUser inject from context . navigate inject from react navigation
export const signIn = async (reqData, navigate, context) => {
  try {
    const url = `${config.apiUrl}/authenticate/login`;
    const { data: user } = await httpService.post(url, reqData);
    if (user.token) {
      // debugger;
      sessionStorageService.setItem("jwt_token", user.token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
      context.setUser(user); // Set User In Context API

      // check layout

      if (user.role.toLowerCase() == "master admin") {
        context.setLayoutSettings(layout2Settings);
      } else {
        context.setLayoutSettings(layout1Settings);
      }

      if (
        user.role &&
        user.role.toLowerCase() !== "distributor" &&
        user.role.toLowerCase() !== "master admin" &&
        user.role.toLowerCase() !== "api user" &&
        user.role.toLowerCase() !== "supplier"
        // &&
        // user.role.toLowerCase() !== "operation"
      ) {
        const menus = await getUserPermission();
        console.log(menus.data);
        context.setNavData(menus.data); // Set Menu In Context API
      }
      NotificationManager.success(`Welcome back, ${user.fullName}!`, "Success");

      // Redirect to specific dashboard

      if (user.role && user.role.toLowerCase() === "distributor") {
        navigate("/distributor/dashboard");
      } else if (user.role && user.role == "Master Admin") {
        navigate("/master-admin/dashboard");
      } else if (user.role && user.role.toLowerCase() == "api user") {
        navigate("/api-user/dashboard");
      } else if (user.role && user.role.toLowerCase() == "supplier") {
        navigate("/supplier/dashboard");
      }
      // else if (user.role && user.role.toLowerCase() == "operation") {
      //   navigate("/operation/dashboard");
      // }
      else {
        navigate("/admin/dashboard");
      }
    }
  } catch (error) {
    let errorData = error.response.data.message;
    NotificationManager.error(errorData, "Error");
  }
};

export const checkIfAlreadyLoggedIn = async (navigate, context) => {
  try {
    const token = sessionStorageService.getItem("jwt_token");
    const url = `${config.apiUrl}/authenticate/user`;
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const { data: user } = await httpService.post(url);
    if (user.token) {
      context.setUser(user); // Set User In Context API
      const roles = await getRoles();
      const requiredRole = roles.data.find(
        (x) => x.roleName.toLowerCase() == user.role.toLowerCase()
      );
      const menus = await getUserPermission();
      context.setNavData(menus.data); // Set Menu In Context API
      NotificationManager.success(`Welcome back, ${user.fullName}!`, "Success");

      // Redirect to specific dashboard
      if (user.role && user.role.toLowerCase() === "distributor") {
        navigate("/distributor/dashboard");
      } else {
        navigate("/admin/dashboard");
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const restoreSession = async (context) => {
  try {
    const token = sessionStorageService.getItem("jwt_token");
    const url = `${config.apiUrl}/authenticate/user`;
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const { data: user } = await httpService.post(url);
    if (user) {
      context.setUser(user); // Set User In Context API
      const roles = await getRoles();
      const requiredRole = roles.data.find(
        (x) => x.roleName.toLowerCase() == user.role.toLowerCase()
      );
      const menus = await getUserPermission();
      context.setNavData(menus.data); // Set Menu In Context API
    }
  } catch (error) {
    console.log(error);
  }
};

export const signOut = (navigate, context) => {
  context.setUser({});
  context.setNavData([]);
  sessionStorageService.removeItem("jwt_token");
  delete axios.defaults.headers.common["Authorization"];
  navigate("/signin");
};
